import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { publicAPI } from '../lib/api';
import { t } from '../lib/i18n';

export default function PolicyPage() {
  const { pageKey } = useParams();
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setPage(null);
    setMissing(false);
    publicAPI.page(pageKey)
      .then(({ data }) => setPage(data))
      .catch(() => setMissing(true));
  }, [pageKey]);

  if (missing) return <p className="py-16 text-center text-sm text-lms-muted">{t('Page not found.')}</p>;
  if (!page) return <p className="text-sm text-lms-muted">{t('Loading…')}</p>;

  return (
    <article className="mx-auto max-w-2xl">
      <h1 className="mb-6 text-2xl font-semibold tracking-tight">{page.title}</h1>
      <div
        className="text-sm leading-relaxed text-lms-muted [&_h2]:mb-2 [&_h2]:mt-5 [&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-lms-text [&_h3]:mb-1.5 [&_h3]:mt-4 [&_h3]:font-semibold [&_h3]:text-lms-text [&_a]:text-lms-accent [&_li]:ml-4 [&_ol]:list-decimal [&_p]:mb-3 [&_ul]:list-disc"
        dangerouslySetInnerHTML={{ __html: page.html }}
      />
    </article>
  );
}
